"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShowClear = void 0;
function useShowClear({ clearable, multiline, focused, hasValue, disabled = false, }) {
    if (multiline && clearable !== "never") {
        throw new Error("Multiline inputs can not be clearable");
    }
    // Do not show if there is no value
    if (!hasValue || clearable === "never" || disabled) {
        return false;
    }
    switch (clearable) {
        case "while-editing":
            return focused;
        case "always":
            return true;
    }
}
exports.useShowClear = useShowClear;
